import { render, staticRenderFns } from "./voteDetail.vue?vue&type=template&id=1755aff7&scoped=true"
import script from "./voteDetail.vue?vue&type=script&lang=js"
export * from "./voteDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755aff7",
  null
  
)

export default component.exports